import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import Icon from '@mulesoft/anypoint-icons/lib/Icon';
import MoreIcon from '@mulesoft/anypoint-icons/lib/svg/more-small.svg';
import ArrowDownIcon from '@mulesoft/anypoint-icons/lib/svg/arrow-down-small.svg';
import Button from '@mulesoft/anypoint-components/lib/Button';
import Popover from '@mulesoft/anypoint-components/lib/Popover';
import MenuItem from '@mulesoft/anypoint-components/lib/MenuItem';
import { ScannerStatusEnum } from '../../types/commonTypes';
import styles from './ScanConfigurationActions.css';

const ScanConfigurationActions = ({
  onRun,
  onEdit,
  onDelete,
  scannerStatus,
  variant = 'icon'
}) => {
  const renderTrigger = () => {
    if (variant === 'button') {
      return (
        <Button
          neutral
          className={styles.actionsButton}
          data-test-id="actions-button"
        >
          Actions
          <Icon size="xs" className={styles.chevronIcon}>
            <ArrowDownIcon />
          </Icon>
        </Button>
      );
    }

    return (
      <Icon
        className={styles.moreActionsIcon}
        aria-label="Show more actions"
        size="s"
        data-test-id="actions-icon"
      >
        <MoreIcon />
      </Icon>
    );
  };

  return (
    <div data-test-id="actions-id" className={styles.actions}>
      <Popover
        anchorPosition="br"
        popupPosition="tr"
        triggerOn={['click']}
        content={
          <div className={styles.actionsMenu}>
            <MenuItem
              display-if={
                scannerStatus !== ScannerStatusEnum.STOPPED.label.toUpperCase()
              }
              onClick={onRun}
            >
              <button type="button" className={styles.actionsMenuItem}>
                Run Now
              </button>
            </MenuItem>
            <MenuItem onClick={onEdit}>
              <button type="button" className={styles.actionsMenuItem}>
                Edit Scanner
              </button>
            </MenuItem>
            <MenuItem data-test-id="actions-delete" onClick={onDelete}>
              <button
                type="button"
                className={classNames(
                  styles.actionsMenuItem,
                  styles.actionsMenuItemDelete
                )}
              >
                Delete Scanner
              </button>
            </MenuItem>
          </div>
        }
      >
        {renderTrigger()}
      </Popover>
    </div>
  );
};

ScanConfigurationActions.propTypes = {
  onRun: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  scannerStatus: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['icon', 'button'])
};

ScanConfigurationActions.defaultProps = {
  variant: 'icon'
};

export default ScanConfigurationActions;
